import { DomainError } from '../errors/domain-error';

export function assertCreatorProfileAvailable(existingProfile: unknown): void {
  if (existingProfile) {
    throw new DomainError('Creator profile already exists');
  }
}

export function calculateCreatorRevenue(
  purchases: Array<{ product: { price: number } }>,
): number {
  return purchases.reduce((sum, purchase) => sum + purchase.product.price, 0);
}
